import type {
  ShipmentPaymentBreakdown,
  ShipmentPaymentItem,
} from '#/entities/shipment'
import type { PaymentBreakdown } from '#/shared/ui/payment-editor'

const PAYMENT_TYPE_LABEL_KEY = {
  income: 'editor.payment.modal.type.income',
  refund: 'editor.payment.modal.type.refund',
  carrier_pay: 'editor.payment.modal.type.carrierPay',
  tip: 'editor.payment.modal.type.tip',
} as const

const PAYMENT_DIRECTION_LABEL_KEY = {
  customer_to_broker: 'editor.payment.modal.direction.customerToBroker',
  broker_to_customer: 'editor.payment.modal.direction.brokerToCustomer',
  broker_to_carrier: 'editor.payment.modal.direction.brokerToCarrier',
} as const

const PAYMENT_DIRECTION_SHORT_KEY = {
  customer_to_broker: 'editor.payment.flowShort.customerToBroker',
  broker_to_customer: 'editor.payment.flowShort.brokerToCustomer',
  broker_to_carrier: 'editor.payment.flowShort.brokerToCarrier',
} as const

const TOTAL_LABEL_KEY = {
  totalCharge: 'editor.payment.cols.totalCharge',
  totalPay: 'editor.payment.cols.totalPay',
} as const

const CHARGED_LABEL_KEY = {
  charged: 'editor.payment.cols.charged',
  paid: 'editor.payment.cols.paid',
} as const

type Translator = (key: string) => string

export function paymentTitle(item: ShipmentPaymentItem, t: Translator): string {
  return t(PAYMENT_TYPE_LABEL_KEY[item.paymentType])
}

export function paymentFlowLabel(
  item: ShipmentPaymentItem,
  t: Translator,
): string {
  if (!item.direction) return ''
  return t(PAYMENT_DIRECTION_LABEL_KEY[item.direction])
}

export function paymentFlowShortLabel(
  item: ShipmentPaymentItem,
  t: Translator,
): string {
  if (!item.direction) return ''
  return t(PAYMENT_DIRECTION_SHORT_KEY[item.direction])
}

export function toPaymentBreakdown(
  breakdown: ShipmentPaymentBreakdown,
  t: Translator,
): PaymentBreakdown {
  return {
    amount: breakdown.amount,
    surcharge: breakdown.surcharge,
    discount: breakdown.discount,
    totalLabel: t(TOTAL_LABEL_KEY[breakdown.totalLabel]),
    total: breakdown.total,
    chargedLabel: t(CHARGED_LABEL_KEY[breakdown.chargedLabel]),
    charged: breakdown.charged,
    chargedVariant: breakdown.chargedVariant,
  }
}
